import React from 'react';
import Head from 'next/head';

import Container from '@/components/Container/Container';
import Header from '@/components/Header/Header';
import styles from '@/styles/Home.module.sass';

export default function AboutPage() {
  return (
    <div className={styles.container}>
      <Head>
        <title>about us | cake-mag.com</title>
        <meta
          key="description"
          name="description"
          content="Get to know a bit more about Cake Magazine"
        />
        <meta
          key="ogDescription"
          property="og:description"
          content="Get to know a bit more about Cake Magazine"
        />
      </Head>
      <Header />
      <Container>
        <section className="section">
          <h1 style={{ marginBottom: '40px' }}>About cake</h1>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            alt="About us"
            height="1357"
            src="https://api.cake-mag.com/wp-content/uploads/2010/09/about-960x1357.jpg"
            width="960"
          />
        </section>
      </Container>
    </div>
  );
}
